export const GET_AUTOPARKS_TRANSPORTS = 'autoparks-transports/GET_AUTOPARKS_TRANSPORTS';
export const getAutoparksTransportsAction = payload => ({
	type: GET_AUTOPARKS_TRANSPORTS,
	payload,
});

export const SET_AUTOPARKS_TRANSPORTS = 'autoparks-transports/SET_AUTOPARKS_TRANSPORTS';
export const setAutoparksTransportsAction = payload => ({
	type: SET_AUTOPARKS_TRANSPORTS,
	payload,
});

export const SET_IS_AUTOPARKS_TRANSPORTS_LOADING = 'autoparks-transports/SET_IS_AUTOPARKS_TRANSPORTS_LOADING';
export const setIsAutoparksTransportsLoadingAction = payload => ({
	type: SET_IS_AUTOPARKS_TRANSPORTS_LOADING,
	payload,
});

export const UPDATE_AUTOPARK_TRANSPORT_ALLOW = 'autoparks-transports/UPDATE_AUTOPARK_TRANSPORT_ALLOW';
export const updateAutoparkTransportAllowAction = payload => ({
	type: UPDATE_AUTOPARK_TRANSPORT_ALLOW,
	payload,
});

export const SET_PAGINATION = 'autoparks-transports/SET_PAGINATION';
export const setPaginationAction = payload => ({
	type: SET_PAGINATION,
	payload,
});

export const RESET_STATE = 'autoparks-transports/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
